import React, { useEffect, useRef, useState } from 'react';
import tw from 'twin.macro';
import { Icon } from '../icon';
import { ArrowIcon, CheckIcon, TimesIcon } from 'icons';
import { Button } from '../button';
import { TextLine } from '../text';

export const DropDownItem = ({
  item,
  children,
  label,
  selectedValue,
  noIcon,
  isRemove,
  IconType,
  iconColor,
  iconRotation,
  ...restProps
}) => {
  return (
    <div
      css={[
        tw`block flex gap-2 justify-between items-center p-0 
        all-child:h-9 all-child:cursor-pointer all-child:flex-grow all-child:flex all-child:items-center`,
        children && tw`text-sm group-[.text-light]:text-light group-[.text-dark]:text-dark`,
        children && selectedValue && tw`font-bold`,
        isRemove &&
          tw`flex justify-between text-icons border-t-2 pt-2 border-icons border-opacity-20`,
      ]}
      onClick={restProps.onClick && restProps.onClick}
      {...restProps}
    >
      {children && <>{children}</>}
      {label && (
        <TextLine bold={selectedValue} smaller>
          {label}
        </TextLine>
      )}
      {(selectedValue || isRemove || IconType) && (
        <Icon
          Type={isRemove ? TimesIcon : IconType || CheckIcon}
          color={isRemove ? 'danger' : iconColor || 'brand'}
          size='medium'
          tw='w-5 flex-grow-0!'
          rotation={iconRotation || 0}
        />
      )}
    </div>
  );
};

export const DropDown = ({
  ClickElement,
  label = 'label',
  isRight,
  isSelect,
  removeProps,
  children,
  hideLabel,
  buttonProps = {},
  iconProps = {
    Type: undefined,
  },
  ...restProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const elRef = useRef();

  const handleClickOutside = (e) => {
    if (!elRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  return (
    <nav ref={elRef} tw='relative m-0' {...restProps}>
      <Button
        label={label}
        hideLabel={hideLabel}
        css={[isOpen && tw`contrast-75`]}
        noHover={isOpen}
        iconProps={{
          ...iconProps,
          Type: iconProps.Type || ArrowIcon,
          size: !iconProps.Type && 'medium',
          rotation: !iconProps.Type && !isOpen && '180',
          animate: !iconProps.Type && true,
        }}
        onClick={() => setIsOpen(!isOpen)}
        {...buttonProps}
      />
      <div
        css={[
          tw`bg-secondary contrast-75 flex flex-col gap-2 text-input-front absolute 
          w-[max-content] min-w-[150px] left-0 mt-1 p-4 pb-3 z-50 transition-all duration-300 ease-in-out transform rounded-md shadow-lg`,
          isRight && tw`left-auto right-0`,
          isOpen ? tw`scale-100 opacity-100` : tw`scale-95 opacity-0 pointer-events-none`,
        ]}
        className='group text-light'
        onClick={() => setIsOpen(!isOpen)}
      >
        {children && !isSelect && <>{children}</>}
        {children && isSelect && <>{children.map((item) => item)}</>}
        {removeProps && (
          <DropDownItem onClick={removeProps.onClick} isRemove>
            {removeProps.label}
          </DropDownItem>
        )}
      </div>
    </nav>
  );
};
